function DeckMiniIcon({ size = 13 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ verticalAlign: 'middle', marginRight: 4 }}>
      <rect x="2" y="7" width="16" height="14" rx="2" ry="2" />
      <path d="M6 3h12a2 2 0 0 1 2 2v12" />
    </svg>
  );
}

function TestMiniIcon({ size = 13 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ verticalAlign: 'middle', marginRight: 4 }}>
      <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
      <rect x="8" y="2" width="8" height="4" rx="1" ry="1" />
      <path d="m9 14 2 2 4-4" />
    </svg>
  );
}

function LockMiniIcon({ size = 13 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ verticalAlign: 'middle', marginRight: 3 }}>
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
  );
}

function ProgressBar({ value, isTest = false }) {
  const percent = Math.round(value * 100);
  return (
    <div className={`lesson-progress-bar${isTest ? " lesson-progress-bar--test" : " lesson-progress-bar--flashcard"}`}>
      <div
        className="lesson-progress-bar__fill"
        style={{ width: `${percent}%` }}
      />
    </div>
  );
}

function LessonTile({
  id,
  title,
  subtitle,
  sequence,
  mandatory,
  completed,
  locked,
  familiarity_score,
  onSee,
  buttonText,
  isTest = false
}) {
  const familiarityPercent = Math.round(familiarity_score * 100);

  return (
    <article
      className={
        `lesson-tile${isTest ? " lesson-tile--test" : " lesson-tile--flashcard"}${mandatory ? " lesson-tile--mandatory" : ""}${locked ? " lesson-tile--locked" : ""}`
      }
    >
      <div className="lesson-tile__header">
        <span className="lesson-tile__sequence">
          {isTest ? (
            <>
              <TestMiniIcon />
              Test {sequence}
            </>
          ) : (
            <>
              <DeckMiniIcon />
              Deck {sequence}
            </>
          )}
        </span>
        {isTest && (
          <span className="lesson-tile__score-pill">
            {familiarityPercent}% Score
          </span>
        )}
        {locked && (
          <span className="lesson-tile__lock" title="Locked">
            <LockMiniIcon />
            Locked
          </span>
        )}
      </div>

      <h4 className="lesson-tile__title">{title}</h4>
      <p className="lesson-tile__subtitle">{subtitle}</p>

      <ProgressBar value={familiarity_score} isTest={isTest} />

      {!locked && (
        <div className="lesson-tile__actions">
          <button
            type="button"
            className={`lesson-tile__btn ${isTest ? "lesson-tile__btn--test" : "lesson-tile__btn--flashcard"}`}
            onClick={() => onSee()}
          >
            {buttonText}
          </button>
        </div>
      )}
    </article>
  );
}

export default LessonTile;
